import React, { useState } from "react"
import { Link } from "gatsby"
import LocationSelect from "../../location-select"
import { useSiteLocation } from "../../../hooks"

const locationRoutes = [
  {
    location: "au/sydney",
    routes: [
      {
        path: "sydney-wedding-music-red-soda-band",
        name: "Sydney",
      },
      {
        path: "hunter-valley-wedding-music-red-soda-band",
        name: "Hunter Valley",
      },
      {
        path: "southern-highlands-wedding-music-red-soda-band",
        name: "Southern Highlands",
      },
      {
        path: "venues/blue-mountains-wedding-music-red-soda-band",
        name: "Blue Mountains",
      },
    ],
  },
  {
    location: "us/boston",
    routes: [
      {
        path: "locations/new-england-wedding-band",
        name: "New England",
      },
      {
        path: "locations/Connecticut-wedding-band",
        name: "Connecticut",
      },
      {
        path: "locations/boston-wedding-band",
        name: "Boston",
      },
      {
        path: "locations/massachusetts-wedding-band",
        name: "Massachusetts",
      },
      {
        path: "locations/rhode-island-wedding-band",
        name: "Rhode Island",
      },
      {
        path: "locations/new-hampshire-wedding-band",
        name: "New Hampshire",
      },
      {
        path: "locations/vermont-wedding-band",
        name: "Vermont",
      },
      {
        path: "locations/maine-wedding-band",
        name: "Maine",
      },
    ],
  },
  {
    location: "ca/toronto",
    routes: [
      {
        path: "ontario-wedding-band",
        name: "Ontario",
      },
      {
        path: "toronto-wedding-band",
        name: "Toronto",
      },
    ],
  },
]

const phoneNumberData = {
  sydney: {
    phoneNumber: "+61280062234",
    phoneDisplayed: "(02) 8006 2234",
  },
  boston: {
    phoneNumber: "+16178652929",
    phoneDisplayed: "(617) 865 2929",
  },
  toronto: {
    phoneNumber: "+16476940999",
    phoneDisplayed: "(647) 694 0999",
  },
}

const BaseNav = ({ location, routeParams }) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const siteLocation = useSiteLocation(location.pathname)

  const currentRoutes = locationRoutes.find(locationRoute =>
    locationRoute.location.includes(siteLocation)
  )

  /* eslint-disable */
  return (
    <div className="base-nav-container flex flex-wrap w-full justify-center xl:justify-end text-xs">
      <div className="link tracking-[1.3px]">
        <Link
          to={`/${routeParams?.location}/red-soda-wedding-band${
            routeParams?.location?.includes("boston") ? "" : "-" + siteLocation
          }/`}
        >
          ABOUT
        </Link>
      </div>
      <div
        className={`${
          isExpanded ? "block" : "hidden"
        } h-screen w-full fixed top-0 left-0 z-20`}
        onClick={() => setIsExpanded(!isExpanded)}
      ></div>
      <div className="link tracking-[1.3px]">
        <div
          className="group relative outline-none"
          onClick={() => setIsExpanded(!isExpanded)}
        >
          <button className="font-semibold tracking-[1.3px]">LOCATIONS</button>
          <div
            className={`border bg-primary rounded w-44 absolute left-0 top-full transition-all ${
              isExpanded
                ? "visible opacity-100 translate-y-1 z-20"
                : "invisible opacity-0"
            }`}
          >
            <ul className="py-1">
              {currentRoutes?.routes?.map(route => {
                return (
                  <Link
                    to={`/${currentRoutes?.location}/${route?.path}/`}
                    key={route?.name}
                  >
                    <li className="block px-4 py-2 hover:bg-secondary">
                      {route?.name}
                    </li>
                  </Link>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
      <div className="link tracking-[1.3px]">
        <Link to={`/${routeParams?.location}/faq/`}>FAQS</Link>
      </div>
      <div className="link tracking-[1.3px]">
        <Link to={`/${routeParams?.location}/blog/`}>BLOG</Link>
      </div>
      <div className="link tracking-[1.3px]">
        <Link to={`/${routeParams?.location}/contact-red-soda/`}>CONTACT</Link>
      </div>
      <div className="link tracking-[1.3px]">
        <a href={`tel:${phoneNumberData[siteLocation]?.phoneNumber}`}>
          TEL : {phoneNumberData[siteLocation]?.phoneDisplayed}
        </a>
      </div>
      <div className="link tracking-[1.3px]">
        <LocationSelect location={location} />
      </div>
    </div>
  )
}

export default BaseNav
